import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid, Divider, Avatar } from '@material-ui/core';
import { InfoWidget, TextLink } from '@ds/react-components';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { ReactComponent as ManageAccountSvg } from 'assets/img-manage-account.svg';

const styles = (theme) => ({
  root: {
    boxShadow: '0 0 0 0 rgba(0, 0, 0, 0.08)',
    '& h4': {
      fontWeight: 'normal',
      //margin: '5px 0'
    },
    minWidth: '250px',
  },
  avatar: {
    marginRight: 10,
    width: '110px',
    height: '110px',
  },
  avatarGrid: {
    maxWidth: '130px',
  },
  avatarText: {
    fontSize: theme.spacing(4),
    color: theme.palette.common.white,
  },
  error: {
    color: theme.palette.common.error,
  },
  textBlack: {
    color: theme.palette.common.black,
  },
  textGray: {
    color: theme.palette.common.darkerText,
    maxHeight: '38px',
    overflow: 'hidden',
    marginBottom: '5px',
    lineHeight: '1',
  },
  textLightGray: {
    color: theme.palette.common.lightText,
    maxHeight: '30px',
    overflow: 'hidden',
    fontSize: '12px',
  },
  divider: {
    marginTop: theme.spacing(2),
  },
  manageAccountContainer: {
    paddingTop: theme.spacing(2),
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
  },
  manageAccountAvatar: {
    backgroundColor: theme.palette.common.primary,
    color: theme.palette.common.white,
  },
  manageAccountLinkWrapper: {
    color: theme.palette.common.black,
    '& path': {
      fill: theme.palette.common.black,
    },
  },
  manageAccountLinkSubText: {
    color: theme.palette.common.darkerText,
  },
});

class AccountDetails extends React.Component {
  render() {
    const { classes, customerDetails } = this.props;
    const { firstName, facilityName, facilityAccountName } = customerDetails;

    return (
      <InfoWidget
        title=""
        isLoading={!firstName}
        classes={{ root: classes.root }}>
        <Grid
          container
          direction="row"
          justify="flex-start"
          className={classes.root}
          spacing={0}>
          <Grid item xs={12}>
            <Typography variant="h1" className={classes.textBlack}>
              {firstName}
            </Typography>
            <Typography variant="h5" className={classes.textGray}>
              {facilityName}
            </Typography>
            <Typography variant="h5" className={classes.textLightGray}>
              {facilityAccountName}
            </Typography>
            <Divider className={classes.divider} />
            <Grid
              container
              className={classes.manageAccountContainer}
              spacing={1}>
              <Grid item>
                <Avatar className={classes.manageAccountAvatar}>
                  <ManageAccountSvg />
                </Avatar>
              </Grid>
              <Grid item>
                <TextLink
                  to="/Accounts"
                  underline={'none'}
                  className={classes.manageAccountLinkWrapper}>
                  <Typography variant={'h5'}>{'Manage Account'}</Typography>
                  <ArrowForwardIcon fontSize={'small'} />
                </TextLink>
                <Typography
                  variant="body2"
                  className={classes.manageAccountLinkSubText}>
                  {'More than one Debitsuccess account?'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </InfoWidget>
    );
  }
}

AccountDetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountDetails);
